export const canCheckoutDirectly = ({
  isCart,
  isServiceInCart,
  isUpsellPluginInstalled,
}: {
  isCart?: boolean;
  isServiceInCart?: boolean;
  isUpsellPluginInstalled?: boolean;
}): boolean => !isCart || (!isServiceInCart && !isUpsellPluginInstalled);
